<template>
  <div class="ordenes-listado">

    <!-- Cabecera -->
    <div class="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
      <h5 class="mb-0 fw-semibold" style="color:var(--text-primary)">
        <i class="bi bi-tools me-2" style="color:var(--primary-main)"></i>Ordenes de Taller
      </h5>
      <button v-if="puedeCrear" class="btn btn-sm btn-primary" @click="$router.push('/taller/ordenes/nuevo')">
        <i class="bi bi-plus-circle me-1"></i>Nueva Orden
      </button>
    </div>

    <!-- Filtros -->
    <div class="card shadow-sm mb-3" style="background:var(--secondary-bg-main);border:1px solid var(--border-main)">
      <div class="card-body py-2 px-3">
        <div class="row g-2 align-items-end">
          <div class="col-6 col-md-2">
            <label class="form-label small mb-1" style="color:var(--text-secondary)">Estado</label>
            <select class="form-select form-select-sm" v-model="filtros.estado" @change="cargarOrdenes"
                    style="background:var(--bg-main);color:var(--text-primary);border-color:var(--border-main)">
              <option value="">Todos</option>
              <option value="abierta">Abierta</option>
              <option value="en_proceso">En proceso</option>
              <option value="completada">Completada</option>
              <option value="cancelada">Cancelada</option>
              <option value="facturada">Facturada</option>
            </select>
          </div>
          <div class="col-6 col-md-3">
            <label class="form-label small mb-1" style="color:var(--text-secondary)">Buscar</label>
            <input type="text" class="form-control form-control-sm" v-model="filtros.busqueda" @change="cargarOrdenes"
                   placeholder="N° orden, propietario, placa..."
                   style="background:var(--bg-main);color:var(--text-primary);border-color:var(--border-main)">
          </div>
          <div class="col-6 col-md-2">
            <label class="form-label small mb-1" style="color:var(--text-secondary)">Desde</label>
            <input type="date" class="form-control form-control-sm" v-model="filtros.fecha_desde" @change="cargarOrdenes"
                   style="background:var(--bg-main);color:var(--text-primary);border-color:var(--border-main)">
          </div>
          <div class="col-6 col-md-2">
            <label class="form-label small mb-1" style="color:var(--text-secondary)">Hasta</label>
            <input type="date" class="form-control form-control-sm" v-model="filtros.fecha_hasta" @change="cargarOrdenes"
                   style="background:var(--bg-main);color:var(--text-primary);border-color:var(--border-main)">
          </div>
          <div class="col-12 col-md-3 d-flex gap-2">
            <button class="btn btn-sm btn-outline-secondary flex-fill" @click="limpiarFiltros">
              <i class="bi bi-x-circle me-1"></i>Limpiar
            </button>
            <button class="btn btn-sm btn-primary flex-fill" @click="cargarOrdenes" :disabled="cargando">
              <i class="bi bi-search me-1"></i>Buscar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Error -->
    <div v-if="errorMensaje" class="alert alert-danger d-flex align-items-center gap-2 mb-3 py-2">
      <i class="bi bi-exclamation-triangle-fill"></i>
      <span>{{ errorMensaje }}</span>
      <button type="button" class="btn-close ms-auto" @click="errorMensaje = ''"></button>
    </div>

    <!-- Tabla -->
    <div class="card shadow-sm" style="background:var(--secondary-bg-main);border:1px solid var(--border-main)">
      <div class="card-body p-0">
        <div v-if="cargando" class="text-center py-5" style="color:var(--text-muted)">
          <div class="spinner-border spinner-border-sm me-2"></div>Cargando ordenes...
        </div>
        <div v-else-if="ordenes.length === 0" class="text-center py-5" style="color:var(--text-muted)">
          <i class="bi bi-inbox fs-2 d-block mb-2"></i>No hay ordenes para los filtros seleccionados.
        </div>
        <div v-else class="table-responsive">
          <table class="table table-sm table-hover mb-0">
            <thead style="background:var(--bg-main)">
              <tr style="color:var(--text-secondary);font-size:.78rem">
                <th class="ps-3">N° Orden</th>
                <th>Vehiculo</th>
                <th>Propietario / Cliente</th>
                <th>Fecha</th>
                <th class="text-end">Total</th>
                <th class="text-center">Estado</th>
                <th class="text-center pe-3">Acciones</th>
              </tr>
            </thead>
            <tbody style="font-size:.82rem">
              <tr v-for="o in ordenes" :key="o.id">
                <td class="ps-3 fw-semibold" style="color:var(--text-primary)">{{ o.numero_orden }}</td>
                <td style="color:var(--text-primary)">
                  {{ o.marca }} {{ o.modelo }}
                  <div v-if="o.placa" class="text-muted" style="font-size:.72rem">Placa: {{ o.placa }}</div>
                </td>
                <td style="color:var(--text-secondary)">{{ o.cliente_nombre || o.propietario_nombre || '—' }}</td>
                <td style="color:var(--text-secondary)">{{ formatearFecha(o.created_at) }}</td>
                <td class="text-end fw-semibold" style="color:var(--accent-success)">{{ dinero(o.total) }}</td>
                <td class="text-center">
                  <span class="badge" :class="badgeEstado(o.estado)">{{ labelEstado(o.estado) }}</span>
                </td>
                <td class="text-center pe-3">
                  <div class="d-flex gap-1 justify-content-center">
                    <button class="btn btn-xs btn-outline-primary" title="Ver detalle" @click="$router.push('/taller/ordenes/' + o.id)">
                      <i class="bi bi-eye"></i>
                    </button>
                    <button
                      v-if="puedeEditar && (o.estado === 'abierta' || o.estado === 'en_proceso')"
                      class="btn btn-xs btn-outline-warning"
                      title="Editar orden"
                      @click="$router.push('/taller/ordenes/' + o.id + '/editar')">
                      <i class="bi bi-pencil"></i>
                    </button>
                    <button
                      v-if="puedeEditar && o.estado !== 'cancelada' && o.estado !== 'facturada'"
                      class="btn btn-xs btn-outline-secondary"
                      title="Cambiar estado"
                      @click="abrirModalEstado(o)">
                      <i class="bi bi-arrow-left-right"></i>
                    </button>
                    <button
                      v-if="puedeEditar && o.estado !== 'cancelada' && o.estado !== 'facturada'"
                      class="btn btn-xs btn-success"
                      title="Convertir a factura"
                      @click="iniciarConversion(o)">
                      <i class="bi bi-receipt-cutoff me-1"></i>Facturar
                    </button>
                    <span v-if="o.estado === 'facturada'" class="text-success small">
                      <i class="bi bi-check-circle-fill me-1"></i>Facturada
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- ── Modal: Cambiar estado ── -->
    <div v-if="modalEstado.visible" class="modal-overlay" @click.self="modalEstado.visible = false">
      <div class="modal-caja" style="max-width:420px">
        <div class="modal-header-caja d-flex align-items-center justify-content-between">
          <span class="fw-semibold" style="color:var(--text-primary)">
            <i class="bi bi-arrow-left-right me-2" style="color:var(--primary-main)"></i>Cambiar Estado
          </span>
          <button class="btn-close-caja" @click="modalEstado.visible = false">✕</button>
        </div>
        <div class="modal-body-caja">
          <p class="small mb-2" style="color:var(--text-secondary)">
            Orden: <strong style="color:var(--text-primary)">{{ modalEstado.orden && modalEstado.orden.numero_orden }}</strong>
          </p>
          <div v-if="modalEstado.nuevoEstado === 'cancelada'" class="alert alert-warning py-2 small mb-3">
            <i class="bi bi-exclamation-triangle me-1"></i>
            Al cancelar, los repuestos ya cargados se devuelven al inventario.
          </div>
          <div class="mb-3">
            <label class="form-label small" style="color:var(--text-secondary)">Nuevo estado</label>
            <select class="form-select form-select-sm" v-model="modalEstado.nuevoEstado"
                    style="background:var(--bg-main);color:var(--text-primary);border-color:var(--border-main)">
              <option value="abierta">Abierta</option>
              <option value="en_proceso">En proceso</option>
              <option value="completada">Completada</option>
              <option value="cancelada">Cancelada</option>
            </select>
          </div>
          <div v-if="modalEstado.nuevoEstado === 'cancelada'" class="mb-3">
            <label class="form-label small" style="color:var(--text-secondary)">Motivo de cancelación</label>
            <input type="text" class="form-control form-control-sm" v-model="modalEstado.motivo"
                   placeholder="Opcional"
                   style="background:var(--bg-main);color:var(--text-primary);border-color:var(--border-main)">
          </div>
        </div>
        <div class="modal-footer-caja d-flex gap-2 justify-content-end">
          <button class="btn btn-outline-secondary btn-sm" @click="modalEstado.visible = false">Cancelar</button>
          <button class="btn btn-primary btn-sm" @click="ejecutarCambioEstado" :disabled="modalEstado.guardando">
            <span v-if="modalEstado.guardando" class="spinner-border spinner-border-sm me-1"></span>
            Guardar
          </button>
        </div>
      </div>
    </div>

    <!-- ── Modal: Confirmar conversión a factura ── -->
    <div v-if="modalConversion.visible" class="modal-overlay" @click.self="modalConversion.visible = false">
      <div class="modal-caja" style="max-width:440px">
        <div class="modal-header-caja d-flex align-items-center justify-content-between">
          <span class="fw-semibold" style="color:var(--text-primary)">
            <i class="bi bi-receipt-cutoff me-2" style="color:var(--accent-success)"></i>Convertir a Factura
          </span>
          <button class="btn-close-caja" @click="modalConversion.visible = false">✕</button>
        </div>
        <div class="modal-body-caja">
          <div class="alert alert-info py-2 small">
            <i class="bi bi-info-circle me-1"></i>
            Se pre-cargarán los datos de la orden <strong>{{ modalConversion.orden && modalConversion.orden.numero_orden }}</strong>
            en el formulario de facturación. Revise y emita la factura desde allí.
          </div>
          <div v-if="modalConversion.cargando" class="text-center py-3" style="color:var(--text-muted)">
            <div class="spinner-border spinner-border-sm me-2"></div>Preparando datos...
          </div>
          <div v-if="modalConversion.error" class="alert alert-danger py-2 small">{{ modalConversion.error }}</div>
        </div>
        <div class="modal-footer-caja d-flex gap-2 justify-content-end">
          <button class="btn btn-outline-secondary btn-sm" @click="modalConversion.visible = false" :disabled="modalConversion.cargando">Cancelar</button>
          <button class="btn btn-success btn-sm" @click="ejecutarConversion" :disabled="modalConversion.cargando">
            <span v-if="modalConversion.cargando" class="spinner-border spinner-border-sm me-1"></span>
            <i v-else class="bi bi-arrow-right-circle me-1"></i>Ir a Facturación
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { ordenTallerService } from '@/services/ordenTallerService'
import notificaciones from '@/services/notificationService.js'

export default {
  name: 'ClientTallerOrdenes',

  computed: {
    puedeCrear() {
      return this.$store.getters.puedoHacer('/taller/ordenes', 'crear')
    },
    puedeEditar() {
      return this.$store.getters.puedoHacer('/taller/ordenes', 'editar')
    }
  },

  data() {
    return {
      ordenes:      [],
      cargando:     false,
      errorMensaje: '',

      filtros: {
        estado:      '',
        busqueda:    '',
        fecha_desde: '',
        fecha_hasta: ''
      },

      modalEstado: {
        visible:    false,
        orden:      null,
        nuevoEstado:'',
        motivo:     '',
        guardando:  false
      },

      modalConversion: {
        visible:  false,
        orden:    null,
        cargando: false,
        error:    ''
      }
    }
  },

  mounted() {
    this.cargarOrdenes()
  },

  methods: {
    async cargarOrdenes() {
      this.cargando     = true
      this.errorMensaje = ''
      try {
        const filtrosActivos = Object.fromEntries(
          Object.entries(this.filtros).filter(([, v]) => v !== '')
        )
        const res = await ordenTallerService.listar(filtrosActivos)
        this.ordenes = res.data.data?.ordenes || []
      } catch {
        this.errorMensaje = 'Error al cargar las ordenes.'
      } finally {
        this.cargando = false
      }
    },

    limpiarFiltros() {
      this.filtros = { estado: '', busqueda: '', fecha_desde: '', fecha_hasta: '' }
      this.cargarOrdenes()
    },

    abrirModalEstado(orden) {
      this.modalEstado.orden       = orden
      this.modalEstado.nuevoEstado = orden.estado
      this.modalEstado.motivo      = ''
      this.modalEstado.guardando   = false
      this.modalEstado.visible     = true
    },

    async ejecutarCambioEstado() {
      this.modalEstado.guardando = true
      try {
        await ordenTallerService.cambiarEstado(
          this.modalEstado.orden.id,
          this.modalEstado.nuevoEstado,
          this.modalEstado.motivo || null
        )
        notificaciones.success('Estado actualizado a "' + this.labelEstado(this.modalEstado.nuevoEstado) + '".')
        this.modalEstado.visible = false
        this.cargarOrdenes()
      } catch (e) {
        notificaciones.error((e?.response?.data?.error) || 'Error al cambiar el estado.')
      } finally {
        this.modalEstado.guardando = false
      }
    },

    iniciarConversion(orden) {
      this.modalConversion.orden    = orden
      this.modalConversion.cargando = false
      this.modalConversion.error    = ''
      this.modalConversion.visible  = true
    },

    async ejecutarConversion() {
      this.modalConversion.cargando = true
      this.modalConversion.error    = ''
      try {
        const res   = await ordenTallerService.convertir(this.modalConversion.orden.id)
        const datos = res.data.data
        this.modalConversion.visible = false
        sessionStorage.setItem('orden_taller_prefill', JSON.stringify(datos))
        this.$router.push('/ventas/facturacion')
      } catch (e) {
        this.modalConversion.error = (e?.response?.data?.error) || 'Error al obtener los datos de la orden.'
      } finally {
        this.modalConversion.cargando = false
      }
    },

    // ── Helpers ──────────────────────────────────────────────
    dinero(valor) {
      return '$ ' + parseFloat(valor || 0).toFixed(2)
    },

    formatearFecha(fecha) {
      if (!fecha) return '-'
      return new Date(fecha).toLocaleDateString('es-EC', {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit'
      })
    },

    labelEstado(estado) {
      const mapa = {
        abierta:    'Abierta',
        en_proceso: 'En proceso',
        completada: 'Completada',
        cancelada:  'Cancelada',
        facturada:  'Facturada'
      }
      return mapa[estado] || estado
    },

    badgeEstado(estado) {
      const mapa = {
        abierta:    'bg-secondary',
        en_proceso: 'bg-warning text-dark',
        completada: 'bg-info text-dark',
        cancelada:  'bg-danger',
        facturada:  'bg-success'
      }
      return mapa[estado] || 'bg-secondary'
    }
  }
}
</script>

<style scoped>
.ordenes-listado {
  padding: 1.25rem;
  color: var(--text-primary);
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.45);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.modal-caja {
  background: var(--secondary-bg-main);
  border: 1px solid var(--border-main);
  border-radius: .5rem;
  width: 100%;
  box-shadow: var(--shadow-md);
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  overflow: hidden;
}

.modal-header-caja {
  padding: .75rem 1rem;
  border-bottom: 1px solid var(--border-main);
  flex-shrink: 0;
}

.modal-body-caja {
  padding: 1rem;
  overflow-y: auto;
  flex: 1;
}

.modal-footer-caja {
  padding: .75rem 1rem;
  border-top: 1px solid var(--border-main);
  flex-shrink: 0;
}

.btn-close-caja {
  background: none;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  color: var(--text-muted);
  line-height: 1;
  padding: 0;
}
.btn-close-caja:hover {
  color: var(--accent-danger);
}

.btn-xs {
  padding: .15rem .4rem;
  font-size: .75rem;
}
</style>
